export default __webpack_public_path__ + "static/media/producto-18.a040374c.jpeg";